import request from 'sb-request'
import { reducers } from 'redux/core'


const fetch = (gender) => {
  if (!gender) {
    throw new Error('gender is empty')
  }

  reducers.view.navigation.setFetching(true)

  return request.post('graphql?name=dropdownMenuOptions', {
    body: {
      query: `{
        dropdownMenuOptions(gender: "${gender}") {
          fragrances {
            brands
            collections {
              id
              title
              description
              url
              image
            }
            fragranceOfTheMonth {
              id
              name
              url
              brand
              img
            }
          }
          personalCare {
            products {
              id
              name
              url
              type
            }
            bestseller {
              id
              name
              url
              brand
              img
            }
          }
          makeup {
            brands
            collections {
              id
              title
              description
              url
              image
            }
            favorite {
              id
              name
              url
              brand
              img
            }
          }
          candles {
            products {
              name
              url
            }
            bestseller {
              id
              name
              url
              brand
              img
            }
            favorite {
              id
              name
              url
              brand
              img
            }
          }
        }
      }`,
    },
    modifyResult: ({ dropdownMenuOptions }) => (dropdownMenuOptions),
  }).then((navigation) => {
    reducers.view.navigation.update({
      ...navigation,
      isFetching: false,
      isFetched: true,
    })
  })
}


export default {
  fetch,
}
